import React from "react";
import {StandList} from "../Stand/StandList/StandList";
import {connect} from "react-redux";
import {CityList} from "../City/CityList/CityList";
import { getStands } from "../Stand/StandAction";
import { getCities } from "../City/CityAction";


export let MyStandsCity = ({user, ...props}) => {
    const filter = {teamLeader: user.id};
    return (<React.Fragment>
        <StandList listTitle="Mis Stands" dialogData={filter} action={getStands} />
        <CityList dialogData={filter} listTitle="Mis Ciudades" action={getCities} />
    </React.Fragment>)
}

const mapStateToProps = (state) => {
    return {user: state.user};
}

MyStandsCity = connect(mapStateToProps)(MyStandsCity);
